"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultTab = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const app_1 = require("app");
const MosaicIcon_1 = require("Views/Shared/Components/MosaicIcon");
const constants_1 = require("../../constants");
const LoadingSpinner_1 = require("Views/Shared/Components/LoadingSpinner/LoadingSpinner");
exports.SearchResultTab = React.forwardRef((props, tabRef) => {
    const { tab, tabs, tabIndex, isTabSelected, isTabsLoading, resultCount, setSelectedTab, setIsHitsAndFiltersLoading, setLastUserAction, } = props;
    const iconName = constants_1.ICON_BY_TAB_KEY_MAP[tab.key];
    const onTabClickHandler = () => {
        if (isTabSelected)
            return;
        setIsHitsAndFiltersLoading(true);
        const selectedTab = tabs[tabIndex];
        setSelectedTab(selectedTab);
        setLastUserAction({ name: app_1.LastUserActionNameEnum.Tab, value: selectedTab.key });
    };
    return ((0, jsx_runtime_1.jsx)("li", { ref: tabRef, children: (0, jsx_runtime_1.jsxs)("button", { role: "tab", type: "button", className: (0, app_1.cn)('px-2xl h-6xl subtitle-md-strong inline-flex rounded-none border-b-2 -outline-offset-2 disabled:cursor-auto', isTabSelected
                ? 'border-brand-primary bg-surface-primary text-brand-primary'
                : 'text-secondary border-transparent disabled:text-disabled enabled:hover:text-primary enabled:hover:border-brand-primary'), onClick: onTabClickHandler, "aria-selected": isTabSelected, disabled: isTabSelected, children: [(0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: iconName, className: "text-inherit mr-2" }), (0, jsx_runtime_1.jsxs)("span", { className: "whitespace-nowrap", children: [tab.title, " (", isTabsLoading ? ((0, jsx_runtime_1.jsx)(LoadingSpinner_1.default, { visible: true, className: (0, app_1.cn)('relative my-0 top-0.5', isTabSelected ? 'text-brand-primary opacity-70' : 'text-df-gray-silver') })) : (resultCount), ")"] })] }) }));
});
